<template>
  <div class="view-page-container">
    <!-- <PremiumPage
      title="Expense Details"
      subtitle="View full society expenditure information"
      showBack
    >
      <template #header-actions>
        <v-btn
          depressed
          class="btn-premium-primary px-6"
          :color="primaryColor"
          :to="'/societyadmin/expense/edit/' + expense.id"
        >
          <v-icon small left color="white">mdi-pencil-outline</v-icon>
          Edit Expense
        </v-btn>
      </template> -->

    <div>
      <!-- ── Unified Detail Card ──────────────────────── -->
      <div class="unified-detail-card">
        <div class="udc-header pb-4">
          <div class="udc-profile-top">
            <div class="udc-profile-left">
              <div class="udc-avatar-wrap" style="border-radius: 16px">
                <div
                  class="udc-placeholder"
                  style="
                    background: var(--sb-act-bg) !important;
                    color: var(--brand);
                  "
                >
                  <v-icon size="32" color="var(--brand)"
                    >mdi-cash-multiple</v-icon
                  >
                </div>
              </div>
              <div class="udc-info">
                <h2 class="udc-name">{{ expense.title }}</h2>
                <div class="udc-meta-row mt-2">
                  <div class="udc-meta-item">
                    <v-icon size="14" color="#0D9972">mdi-shape-outline</v-icon>
                    <span class="udc-meta-text">{{
                      expense.category
                        ? expense.category.name
                        : "General Expense"
                    }}</span>
                  </div>
                  <span class="udc-meta-sep">|</span>
                  <div class="udc-meta-item">
                    <v-icon size="14" color="#64748B"
                      >mdi-calendar-clock</v-icon
                    >
                    <span class="udc-meta-text">{{
                      expense.date | formatDateTime
                    }}</span>
                  </div>
                  <span class="udc-meta-sep">|</span>
                  <div class="udc-meta-item">
                    <span
                      class="udc-meta-text font-weight-bold"
                      style="color: #ef4444; font-size: 16px"
                      >₹{{ Number(expense.amount).toLocaleString() }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="udc-profile-right">
              <button
                class="udc-back-btn"
                @click="$router.go(-1)"
                :style="{ color: buttonColor, borderColor: buttonColor }"
              >
                <v-icon size="16" class="arrow" :style="{ color: buttonColor }"
                  >mdi-arrow-left</v-icon
                >
                BACK
              </button>
            </div>
          </div>
        </div>

        <div class="udc-content-wrap">
          <!-- ── Note ────────────────────────────── -->
          <div class="expense-content-section mb-10">
            <div class="premium-field-label mb-4">Note / Description</div>
            <div class="expense-note-box">
              {{ expense.note }}
            </div>
          </div>

          <!-- ── Attachments ──────────────────────── -->
          <div
            class="expense-attachments-section"
            v-if="added_documents.length"
          >
            <div class="premium-field-label mb-4">Attachments / Bills</div>
            <div class="doc-grid">
              <div
                v-for="(item, idx) in added_documents"
                :key="item.document_url"
                class="doc-card"
                @click="imgClick(idx)"
              >
                <v-img
                  v-if="item.file_type == 'image'"
                  :src="base_url + '/uploads/' + item.document_url"
                  class="doc-card-img"
                  contain
                />
                <div v-else class="doc-card-placeholder">
                  <v-icon color="#EF4444" size="52">mdi-file-pdf-box</v-icon>
                  <span class="doc-card-placeholder-label">PDF</span>
                </div>
                <div class="doc-card-overlay">
                  <div class="doc-overlay-btn">
                    <v-icon size="16" color="white">mdi-eye-outline</v-icon>
                    <span>View</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </PremiumPage> -->

    <!-- ── Media Viewer ── -->
    <MediaViewer
      v-model="imageDialog"
      :items="mediaItems"
      :index="mediaIndex"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";
import MediaViewer from "../../common/MediaViewer.vue";

export default {
  name: "ViewExpense",
  components: { MediaViewer },
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      expense: {
        title: "",
        note: "",
        amount: 0,
      },
      added_documents: [],
      base_url: process.env.VUE_APP_API_URL,
      imageDialog: false,
      mediaIndex: 0,
    };
  },
  computed: {
    ...mapState("theme", ["buttonColor"]),
    mediaItems() {
      return this.added_documents.map((doc) => ({
        url: this.base_url + "/uploads/" + doc.document_url,
        type: doc.file_type === "image" ? "image" : "document",
        name: doc.document_url ? doc.document_url.split("/").pop() : "file",
      }));
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    filterActiveDocuments(docs) {
      return (docs || []).filter((doc) => !doc.deleted);
    },
    getExpenseDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/expenses/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;
          if (data.status) {
            _self.expense = data.expense;
            _self.added_documents = _self.filterActiveDocuments(data.expense.documents || []);
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    imgClick(idx) {
      this.mediaIndex = idx;
      this.imageDialog = true;
    },
    getFormattedDate(date) {
      return date
        ? moment(Number(date)).format("DD MMM, YYYY · hh:mm A")
        : "N/A";
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getExpenseDetail();
  },
};
</script>

<style scoped>
.view-page-container {
  padding: 24px;
}

.edit-btn {
  border-radius: 12px !important;
  font-weight: 700;
  text-transform: none;
  height: 42px !important;
}

/* ── Unified Detail Card ── */
.unified-detail-card {
  /* background: var(--surface); */
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
}

/* Header section */
.udc-header {
  padding: 16px 16px 0px 16px;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}

.udc-profile-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  position: relative;
}

.udc-profile-left {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding-right: 100px;
}

.udc-avatar-wrap {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  background: var(--surface2);
}
.udc-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.udc-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.udc-info {
  flex: 1;
}

.udc-name {
  font-family: "Bricolage Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--tx);
  margin: 0;
  letter-spacing: -0.01em;
}

.udc-meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}
.udc-meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.udc-meta-text {
  font-size: 13.5px;
  color: var(--tx2);
  font-weight: 500;
}
.udc-meta-sep {
  color: var(--border);
  font-size: 14px;
  opacity: 0.5;
}

/* Back Button */
/* Back Button */
.udc-profile-right {
  position: absolute;
  top: 0;
  right: 0;
  flex-shrink: 0;
}

.udc-back-btn {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 0 14px 0 10px !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  letter-spacing: 0.05em !important;
  border-radius: 8px !important;
  color: var(--btn-color) !important;
  border: 1px solid var(--btn-color) !important;
  background: var(--surface2) !important;
  height: 38px !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
}

.udc-back-btn:hover {
  background: var(--surface2) !important;
  border-color: var(--btn-color) !important;
}

.arrow {
  color: var(--btn-color) !important;
}

/* Content Area */
.udc-content-wrap {
  /* background: var(--surface2); */
  min-height: 400px;
  padding: 24px;
}

.premium-field-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--tx3, #64748b);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.expense-note-box {
  font-size: 15px;
  line-height: 1.7;
  color: var(--tx2);
  white-space: pre-line;
  /* max-width: 800px; */
}

/* ── Attachments Grid ── */
.attachment-card-premium {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  aspect-ratio: 1;
  height: 200px;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  cursor: pointer;
}
.attachment-card-premium:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
}
.attachment-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.attachment-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fef2f2;
}

.attachment-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}
.attachment-card-premium:hover .attachment-overlay {
  opacity: 1;
}

.overlay-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-size: 13px;
  font-weight: 700;
}

/* Responsive */
@media (max-width: 768px) {
  .udc-profile-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .udc-profile-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .udc-meta-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .udc-meta-sep {
    display: none;
  }
  .udc-content-wrap {
    padding: 16px;
  }
}
</style>
